module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5ti4s"))).then(() => parcelRequire('f4eak'));